import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between flex-wrap gap-3 mb-5" }
const _hoisted_2 = { class: "d-flex align-center gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-caption text-medium-emphasis mt-1"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex align-center flex-wrap gap-2" }
const _hoisted_6 = {
  class: "text-h5 font-weight-bold",
  style: {"color":"#1a5f4a"}
}
const _hoisted_7 = { class: "d-flex align-center gap-1" }
const _hoisted_8 = {
  class: "text-h5 font-weight-bold",
  style: {"color":"#c9a227"}
}
const _hoisted_9 = {
  key: 0,
  class: "material-symbols-outlined",
  style: {"color":"#c9a227","font-size":"20px"}
}
const _hoisted_10 = { class: "text-body-2 mt-1" }
const _hoisted_11 = {
  class: "font-weight-medium",
  style: {"color":"#1a5f4a"}
}
const _hoisted_12 = { class: "text-medium-emphasis" }
const _hoisted_13 = {
  key: 0,
  class: "text-center text-medium-emphasis py-8"
}
const _hoisted_14 = { class: "question-cell" }
const _hoisted_15 = { class: "text-caption text-medium-emphasis" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_17 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_18 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_19 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_20 = {
  key: 2,
  class: "d-flex justify-center align-center gap-3 py-3"
}
const _hoisted_21 = { class: "text-caption text-medium-emphasis" }
const _hoisted_22 = { class: "d-flex align-center mb-3 text-caption text-medium-emphasis" }
const _hoisted_23 = { class: "font-italic" }
const _hoisted_24 = {
  class: "text-body-2 mb-0",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_27 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_28 = {
  class: "text-caption font-weight-medium mb-1",
  style: {"color":"#1a5f4a"}
}
const _hoisted_29 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_30 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_31 = {
  key: 1,
  class: "text-caption",
  style: {"font-family":"monospace"}
}
const _hoisted_32 = { class: "text-body-2" }
const _hoisted_33 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_34 = {
  class: "material-symbols-outlined",
  style: {"font-size":"20px"}
}

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from '@/plugins/axios'
import { useToast } from 'vue-toastification'
import DocumentPreviewModal from '@/components/Apps/LawAssistant/DocumentPreviewModal.vue'
import {
  fetchUserQuestions,
  type UserQuestionsResponse,
  type UserQuestionItem,
  type QuestionSource,
  type StatsPeriod,
} from '@/services/adminStatsApi'

const perPage    = 20


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUserQuestionsPage',
  setup(__props) {

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
const toast = useToast()

const route = useRoute()
const username = route.params.username as string
const today = new Date().toISOString().slice(0, 10)

const period     = ref<StatsPeriod>('month')
const customFrom = ref(today)
const customTo   = ref(today)
const loading    = ref(false)
const error      = ref<string | null>(null)
const data       = ref<UserQuestionsResponse | null>(null)
const currentPage = ref(1)
const dialog   = ref(false)
const selected = ref<UserQuestionItem | null>(null)

const documentPreviewVisible = ref(false)
const selectedDocument       = ref<QuestionSource | null>(null)
const downloadingSourceFile  = ref<string | null>(null)

const headers = [
  { title: 'Tarih',  key: 'asked_at',  width: '150px' },
  { title: 'Soru',   key: 'question' },
  { title: 'Puan',   key: 'rating',   width: '120px', sortable: false },
  { title: 'Yorum',  key: 'comment',  width: '200px', sortable: false },
]

async function load(page = 1) {
  loading.value = true
  error.value = null
  currentPage.value = page
  try {
    const dateRange = period.value === 'custom'
      ? { from: customFrom.value, to: customTo.value }
      : undefined
    const res = await fetchUserQuestions(username, period.value, dateRange, page, perPage)
    data.value = res.data
  } catch (e: any) {
    error.value = e?.response?.data?.message ?? e?.message ?? 'Bir hata oluştu'
  } finally {
    loading.value = false
  }
}

function onPeriodChange() {
  if (period.value !== 'custom') load()
}

function onCustomRangeChange() {
  if (customFrom.value && customTo.value && customFrom.value <= customTo.value) load()
}

function goToPage(page: number) {
  load(page)
}

function openDetail(item: UserQuestionItem) {
  selected.value = item
  dialog.value = true
}

function formatDate(dt: string): string {
  if (!dt) return '—'
  return new Date(dt).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

// --- Kaynak (Dayanak Belgeler) yardımcıları — ana chat ekranıyla aynı mantık ---
function sourceGroups(sources: QuestionSource[]) {
  const groups: Record<string, QuestionSource[]> = { yasatuzuk: [], karar: [], unknown: [] }
  for (const s of sources) {
    const folder = String(s?.folder || '').toLowerCase()
    if (folder === 'yasatuzuk') groups.yasatuzuk.push(s)
    else if (folder === 'karar' || folder === 'kararlar') groups.karar.push(s)
    else groups.unknown.push(s)
  }
  return [
    { key: 'y', title: 'Yasa & Tüzükler', items: groups.yasatuzuk },
    { key: 'k', title: 'Emsal Kararlar', items: groups.karar },
    { key: 'u', title: 'Diğer Kaynaklar', items: groups.unknown },
  ].filter((g) => g.items.length)
}

function kunyeCourt(src: QuestionSource): string | null {
  const c = String(src?.citation || '')
  return c.includes('|') ? c.split('|')[0].trim() : null
}

function kunyeNumbers(src: QuestionSource): string | null {
  const c = String(src?.citation || '')
  if (c.includes('|')) {
    return c.split('|').slice(1)
      .map((s) => s.trim().replace(/^Dağıtım:\s*/i, '').replace(/^Dava No:\s*/i, 'Dava '))
      .filter(Boolean)
      .join(' · ')
  }
  return /\d/.test(c) && c !== src?.file_name ? c : null
}

function formatSourceName(filename?: string): string {
  if (!filename) return '—'
  return filename.replace(/\.(docx?|pdf)$/i, '').replace(/_/g, ' ')
}

// Önizleme: ana chat ile aynı DocumentPreviewModal bileşenini kullanır.
function openDocumentPreview(src: QuestionSource) {
  selectedDocument.value = src
  documentPreviewVisible.value = true
}

// İndirme: ana chat'teki downloadSourceFile ile aynı endpoint/akış.
async function downloadSourceFile(src: QuestionSource) {
  const fileName = src?.file_name
  if (!fileName) {
    toast.error('Dosya adı bulunamadı')
    return
  }
  downloadingSourceFile.value = fileName
  try {
    const fileId = src.file_id || 'local'
    const response = await axios.get(`${API_BASE_URL}/files/${fileId}/download`, {
      params: { filename: fileName },
      responseType: 'blob',
    })
    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/octet-stream',
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    toast.success('Dosya indiriliyor...')
  } catch (err: any) {
    if (err?.response?.status === 404) {
      toast.warning('Dosya bulunamadı. Lütfen mevzuat.mahkemeler.net adresinden kontrol ediniz.', { timeout: 6000 })
    } else {
      toast.error('Dosya indirilirken bir hata oluştu.')
    }
  } finally {
    downloadingSourceFile.value = null
  }
}

onMounted(() => load())

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          icon: "",
          variant: "text",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createElementVNode("span", { class: "material-symbols-outlined" }, "arrow_back", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "mb-0" }, "Kullanıcı Soruları", -1)),
          (data.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[12] || (_cache[12] = _createElementVNode("span", {
                  class: "material-symbols-outlined",
                  style: {"font-size":"14px","vertical-align":"middle"}
                }, "person", -1)),
                _createTextVNode(" " + _toDisplayString(data.value.user.name) + " ", 1),
                (data.value.user.username)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(data.value.user.username) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn_toggle, {
          modelValue: period.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((period).value = $event)),
            onPeriodChange
          ],
          mandatory: "",
          color: "primary",
          variant: "outlined",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { value: "today" }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Bugün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "yesterday" }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("Dün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "week" }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("Son 7 Gün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "month" }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("Son 30 Gün", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, { value: "custom" }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Özel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (period.value === 'custom')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_text_field, {
                modelValue: customFrom.value,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((customFrom).value = $event)),
                  onCustomRangeChange
                ],
                type: "date",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"150px"},
                max: customTo.value || _unref(today)
              }, null, 8, ["modelValue", "max"]),
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-medium-emphasis" }, "—", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: customTo.value,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((customTo).value = $event)),
                  onCustomRangeChange
                ],
                type: "date",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"150px"},
                min: customFrom.value,
                max: _unref(today)
              }, null, 8, ["modelValue", "min", "max"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "error",
          class: "mb-4",
          closable: "",
          "onClick:close": _cache[4] || (_cache[4] = ($event: any) => (error.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                return _createVNode(_component_v_col, {
                  key: n,
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "card" })
                  ]),
                  _: 1
                })
              }), 64))
            ]),
            _: 1
          }),
          _createVNode(_component_v_skeleton_loader, {
            type: "table",
            class: "mt-4"
          })
        ], 64))
      : (data.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_v_row, { class: "mb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "trezo-card bg-white border-0 shadow-none pa-4",
                      style: {"border-left":"4px solid #1a5f4a"}
                    }, {
                      default: _withCtx(() => [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Toplam Soru", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(data.value.total), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "trezo-card bg-white border-0 shadow-none pa-4",
                      style: {"border-left":"4px solid #c9a227"}
                    }, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Ortalama Puan", -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(data.value.avg_rating ?? '—'), 1),
                          (data.value.avg_rating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "star"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "trezo-card bg-white border-0 shadow-none pa-4",
                      style: {"border-left":"4px solid #6b7a72"}
                    }, {
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Puanlama Durumu", -1)),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(data.value.rated_count) + " puanlı", 1),
                          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-medium-emphasis mx-1" }, "·", -1)),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(data.value.unrated_count) + " puansız", 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none" }, {
              default: _withCtx(() => [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "v-card-header" }, [
                  _createElementVNode("h5", { class: "mb-0" }, "Sorular")
                ], -1)),
                (!data.value.questions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Bu dönemde soru bulunamadı. "))
                  : (_openBlock(), _createBlock(_component_v_data_table, {
                      key: 1,
                      headers: headers,
                      items: data.value.questions,
                      density: "compact",
                      "items-per-page": perPage,
                      "items-per-page-options": [20, 50, 100],
                      "onClick:row": _cache[5] || (_cache[5] = (_, row) => openDetail(row.item)),
                      style: {"cursor":"pointer"}
                    }, {
                      "item.question": _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.question), 1)
                      ]),
                      "item.asked_at": _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(item.asked_at)), 1)
                      ]),
                      "item.rating": _withCtx(({ item }) => [
                        (item.rating)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                return _createElementVNode("span", {
                                  key: i,
                                  class: "material-symbols-outlined",
                                  style: _normalizeStyle({ fontSize: '15px', color: i <= item.rating ? '#c9a227' : '#ddd' })
                                }, "star", 4)
                              }), 64))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
                      ]),
                      "item.comment": _withCtx(({ item }) => [
                        (item.comment)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.comment), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
                      ]),
                      _: 1
                    }, 8, ["items"])),
                (data.value.last_page > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        density: "compact",
                        disabled: currentPage.value <= 1,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage(currentPage.value - 1)))
                      }, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("Önceki", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(currentPage.value) + " / " + _toDisplayString(data.value.last_page), 1),
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        density: "compact",
                        disabled: currentPage.value >= data.value.last_page,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (goToPage(currentPage.value + 1)))
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("Sonraki", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialog).value = $event)),
      "max-width": "800",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        (selected.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center pa-4 pb-2" }, {
                  default: _withCtx(() => [
                    _cache[28] || (_cache[28] = _createElementVNode("span", {
                      class: "material-symbols-outlined mr-2",
                      style: {"color":"#1a5f4a"}
                    }, "forum", -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-body-1 font-weight-medium" }, "Soru & Cevap Detayı", -1)),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (dialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, "close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, {
                  class: "pa-4",
                  style: {"max-height":"70vh","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", {
                        class: "material-symbols-outlined mr-1",
                        style: {"font-size":"16px"}
                      }, "schedule", -1)),
                      _createElementVNode("span", null, _toDisplayString(formatDate(selected.value.asked_at)), 1),
                      (selected.value.rating)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "mx-2" }, "·", -1)),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                              return _createElementVNode("span", {
                                key: i,
                                class: "material-symbols-outlined",
                                style: _normalizeStyle({ fontSize: '15px', color: i <= selected.value.rating ? '#c9a227' : '#ddd' })
                              }, "star", 4)
                            }), 64))
                          ], 64))
                        : _createCommentVNode("", true),
                      (selected.value.comment)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "mx-2" }, "·", -1)),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(selected.value.comment), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_sheet, {
                      color: "#f5f7f6",
                      rounded: "",
                      class: "pa-3 mb-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1 d-flex align-center" }, [
                          _createElementVNode("span", {
                            class: "material-symbols-outlined mr-1",
                            style: {"font-size":"15px"}
                          }, "help"),
                          _createTextVNode(" SORU ")
                        ], -1)),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(selected.value.question_full || selected.value.question), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_sheet, {
                      color: "#f0f7f4",
                      rounded: "",
                      class: "pa-3"
                    }, {
                      default: _withCtx(() => [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2 d-flex align-center" }, [
                          _createElementVNode("span", {
                            class: "material-symbols-outlined mr-1",
                            style: {"font-size":"15px"}
                          }, "smart_toy"),
                          _createTextVNode(" MAHAI CEVABI ")
                        ], -1)),
                        (selected.value.answer)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "text-body-2 answer-content",
                              innerHTML: selected.value.answer
                            }, null, 8, _hoisted_25))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "Cevap bulunamadı."))
                      ]),
                      _: 1
                    }),
                    (selected.value.sources && selected.value.sources.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2 d-flex align-center" }, [
                            _createElementVNode("span", {
                              class: "material-symbols-outlined mr-1",
                              style: {"font-size":"15px"}
                            }, "menu_book"),
                            _createTextVNode(" DAYANAK BELGELER ")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceGroups(selected.value.sources), (grp) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: grp.key,
                              class: "mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_28, _toDisplayString(grp.title), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.items, (src, i) => {
                                return (_openBlock(), _createBlock(_component_v_sheet, {
                                  key: grp.key + '-' + i,
                                  color: "#f5f7f6",
                                  rounded: "",
                                  class: "pa-2 mb-1 d-flex align-center gap-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_29, [
                                      (kunyeCourt(src))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(kunyeCourt(src)), 1))
                                        : _createCommentVNode("", true),
                                      (kunyeNumbers(src))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(kunyeNumbers(src)), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_32, [
                                        _createTextVNode(_toDisplayString(src.yasa_adi || formatSourceName(src.file_name)) + " ", 1),
                                        (src.chunk_count && src.chunk_count > 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, " · " + _toDisplayString(src.chunk_count) + " bölüm ", 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "text",
                                      size: "small",
                                      disabled: src.available === false,
                                      title: src.available === false ? 'Dosya yerelde bulunamadı' : 'Belgeyi önizle',
                                      onClick: _withModifiers(($event: any) => (openDocumentPreview(src)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                        _createElementVNode("span", {
                                          class: "material-symbols-outlined",
                                          style: {"font-size":"20px"}
                                        }, "visibility", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["disabled", "title", "onClick"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "text",
                                      size: "small",
                                      disabled: src.available === false || downloadingSourceFile.value === src.file_name,
                                      title: src.available === false ? 'Dosya yerelde bulunamadı' : 'Belgeyi indir',
                                      onClick: _withModifiers(($event: any) => (downloadSourceFile(src)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(downloadingSourceFile.value === src.file_name ? 'hourglass_empty' : 'download'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "title", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DocumentPreviewModal, {
      modelValue: documentPreviewVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((documentPreviewVisible).value = $event)),
      document: selectedDocument.value
    }, null, 8, ["modelValue", "document"])
  ]))
}
}

})